import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ng-accordion',
  templateUrl: './ng-accordion.component.html',
  styleUrls: ['./ng-accordion.component.css']
})
export class NgAccordionComponent {

  @Input() title: string = '';
  @Input() widgetId: string = "";
  @Input() headerClass: string = "";

}
